/**
 * @generated SignedSource<<1d50619615b464c5c7618ae4ad3f9b91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChatThreadPurposeEnum = "applicant_feedback" | "hiring";
import { FragmentRefs } from "relay-runtime";
export type ChatThreadEditDialog_Thread$data = {
  readonly avatarUrl: string | null | undefined;
  readonly id: string;
  readonly purpose: ChatThreadPurposeEnum | null | undefined;
  readonly recipient: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadEditDialog_Recipient">;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly users: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentType": "ChatThreadEditDialog_Thread";
};
export type ChatThreadEditDialog_Thread$key = {
  readonly " $data"?: ChatThreadEditDialog_Thread$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadEditDialog_Thread">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadEditDialog_Thread",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purpose",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "recipient",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatThreadEditDialog_Recipient"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ChatThread",
  "abstractKey": null
};
})();

(node as any).hash = "56a3454e2afba8a8d224f965263f09dc";

export default node;
